import { render } from "./advancePaymentPopup.vue?vue&type=template&id=3889f4a4&scoped=true"
import script from "./advancePaymentPopup.vue?vue&type=script&lang=js"
export * from "./advancePaymentPopup.vue?vue&type=script&lang=js"

import "./advancePaymentPopup.vue?vue&type=style&index=0&id=3889f4a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3889f4a4"]])

export default __exports__